import axios from '@axios'

const route = 'aesthetics/body_assessment'

export default {
  namespaced: true,
  state: {
    bodyAssessments: [],
  },
  getters: {
    getBodyAssessments(state) {
      return state.bodyAssessments
    },
  },
  mutations: {
    setBodyAssessments(state, bodyAssessments) {
      state.bodyAssessments = bodyAssessments
    },
  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filters,
    }) {
      return axios.post(`${route}/index?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filters)
    },

    store(context, bodyAssessment) {
      return axios.post(route, bodyAssessment)
    },

    update(context, bodyAssessment) {
      return axios.put(`${route}/${bodyAssessment.id}`, bodyAssessment)
    },

    destroy(context, bodyAssessment) {
      return axios.delete(`${route}/${bodyAssessment.id}`)
    },
  },
}
